<template>
    <Card :title="$route.meta.title" dis-hover>
        <Form inline @keydown.enter.native.prevent="refreshGetTableData">
            <FormItem>
                <Input v-model="query.userName" placeholder="登录名" clearable></Input>
            </FormItem>
            <FormItem>
                <depart-sel v-model="query.department.id" :departmentType="1" placeholder="请选择检测单位" width="200px"></depart-sel>
            </FormItem>
            <FormItem>
                <Button type="primary" icon="ios-search" @click="refreshGetTableData">查询</Button>
            </FormItem>
            <Button type="success" icon="md-add" @click="handleOperation(null,'ADD')">
                添加
            </Button>
        </Form>

        <Table :loading="tableLoading" :columns="tableColumns" :data="tableList">
            <template slot-scope="{row}" slot="operation">
                <a v-if="row.superAdmin != 1" class="opt-txt" @click="handleOperation(row,'EDIT')">编辑</a>
                <a v-if="row.superAdmin != 1" class="opt-txt" @click="handleOperation(row,'DELETE')">删除</a>
            </template>
        </Table>
        <page-model :paging="page" :total="total" @page-change="handlePageChange"></page-model>
        <Modal v-model="modalVisible" :title="modalTitle">
            <Spin size="large" fix v-if="modalLoading"></Spin>
            <Form ref="baseForm" :model="modalForm" :label-width="100">
                <FormItem label="登录名" prop="userName" :rules="[rules.required]" :disabled="modalForm.id==null">
                    <Input v-model="modalForm.userName" placeholder="登录名"></Input>
                </FormItem>
                <FormItem label="编号" prop="staffNo" :rules="[rules.required]">
                    <Input v-model="modalForm.staffNo" placeholder="用户编号"></Input>
                </FormItem>
                <FormItem label="姓名" prop="name" :rules="[rules.required]">
                    <Input v-model="modalForm.name" placeholder="姓名"></Input>
                </FormItem>
                <FormItem label="手机号" prop="mobile" :rules="[rules.required]">
                    <Input v-model="modalForm.mobile" placeholder="手机号"></Input>
                </FormItem>
                <FormItem label="身份证号" prop="idNo" :rules="[rules.required]">
                    <Input v-model="modalForm.idNo" placeholder="身份证号"></Input>
                </FormItem>
                <FormItem label="入职时间" prop="signDate" :rules="[rules.required]">
                    <DatePicker type="date" placeholder="入职时间" format="yyyy-MM-dd" :value="modalForm.signDate" @on-change="signDateChange"></DatePicker>
                </FormItem>
                <FormItem label="文化程度" prop="edu" :rules="[rules.required]">
                    <Input v-model="modalForm.edu" placeholder="文化程度"></Input>
                </FormItem>
                <FormItem label="岗位" prop="positions" :rules="[rules.requiredArray]">
                    <Select v-model="modalForm.positions" multiple style="width:260px">
                        <Option :value="1">技术负责人</Option>
                        <Option :value="2">质量负责人</Option>
                        <Option :value="3">授权签字人</Option>
                        <Option :value="4">检验员</Option>
                        <Option :value="5">最高管理者</Option>
                        <Option :value="6">其他</Option>
                    </Select>
                </FormItem>
                <FormItem label="岗位确认文件编号" prop="jobNo" :rules="[rules.required]">
                    <Input v-model="modalForm.jobNo" placeholder="岗位确认文件编号"></Input>
                </FormItem>
                <FormItem label="岗位确认文件起止时间">
                    <DatePicker type="daterange" placeholder="岗位确认文件起止时间" :value="[modalForm.jobNoStart, modalForm.jobNoEnd]" @on-change="jobNoRangeChange"></DatePicker>
                </FormItem>
                <FormItem label="检测单位" prop="department.id" :rules="[rules.requiredNumber]">
                    <depart-sel v-model="modalForm.department.id" :departmentType="1" placeholder="请选择检测单位"></depart-sel>
                </FormItem>
                <Row>
                    <Col span="8">
                        <FormItem label="身份证正面">
                            <do-picture v-model="modalForm.idPic1"></do-picture>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="身份证反面">
                            <do-picture v-model="modalForm.idPic2"></do-picture>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="岗位确认文件">
                            <do-picture v-model="modalForm.jobPic"></do-picture>
                        </FormItem>
                    </Col>
                </Row>
                <FormItem label="角色" prop="role.id" :rules="[rules.requiredNumber]">
                    <role-sel v-model="modalForm.role.id" :roleType="2"></role-sel>
                </FormItem>
                <FormItem label="密码" prop="password" :rules="[rules.required]" v-show="modalForm.id==null">
                    <Input type="password" v-model="modalForm.password" placeholder="密码"></Input>
                </FormItem>
                <FormItem label="确认密码" prop="confirmPassword" :rules="[rules.required]" v-show="modalForm.id==null">
                    <Input type="password" v-model="modalForm.confirmPassword" placeholder="确认密码"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="modalVisible = false">取消</Button>
                <Button type="primary" @click="handleSubmit">确定</Button>
            </div>
        </Modal>

    </Card>
</template>
<script>
    import iSetting from '@/module/base/api/iSetting'
    import iUser from '@/module/base/api/iUser'
    import tableHelper from '@/mixins/tableHelper';
    import rules from '@/libs/rules';
    import DepartSel from '@/module/main/components/DepartSel'
    import RoleSel from '@/module/main/components/RoleSel'
    import DoPicture from '_c/auto-form/DoPicture';
    import _don from '@/libs/doson'

    const modalFormTemplate = {
        id: null,
        userName: null,
        name: null,
        mobile: null,
        departmentId:null,
        department: {id:null},
        role:{id:null},
        password:null,
        confirmPassword:null,
        idNo:null,
        signDate:null,
        edu:null,
        position:null,
        jobNo:null,
        jobNoStart:null,
        jobNoEnd:null,
        idPic1:null,
        idPic2:null,
        jobPic:null,
        positions:[],
        places:[],
        staffNo:null,
        userLevel:3
    };

    export default {
        name: "employee_mng",
        mixins: [tableHelper],
        components: {
            DepartSel,RoleSel,DoPicture
        },
        data() {
            return {
                rules,
                query:{
                    departmentAdmin:null,
                    userName:null,
                    userLevel:null,
                    department:{
                        id:null,
                        departmentType:1
                    },
                    departmentAdmin:0
                },

                tableColumns: [
                    {title: '序号', key: 'idx', width: 80},
                    {title: '登录名', key: 'userName', width: 200},
                    {title: '编号', key: 'staffNo', width: 200},
                    {title: '姓名', key: 'name'},
                    {title: '手机号', key: 'mobile'},
                    {title: '检测单位', key: 'departmentName'},
                    {title: '添加时间', key: 'addTime', width: 180},
                    {title: '操作', slot: 'operation', width: 160}
                ],

                modalTitle:'添加检测人员',
                modalVisible:false,
                modalLoading:false,
                modalForm:_don.cloneWithModal(modalFormTemplate),

                roleType:1,
            }
        },
        mounted() {
            this.getTableData()
        },
        methods: {
            getTableData() {
                if (this.query.userName == '') {
                    this.query.userName = null
                }
                iUser.userList(this.page, this.query).then(res => {
                    var i = 1
                    this.tableList = res.content.map(e => {
                        e.departmentName = e.department.departmentName
                        e.idx = (this.page.page-1)*this.page.size+i++
                        return e
                    });
                    this.total = res.totalElements
                }).loadingSwitch(this, 'tableLoading');
            },
            async handleOperation(row, type) {
                if (type === 'ADD') {
                    this.$refs.baseForm.resetFields();
                    this.modalVisible = true
                    this.modalForm = _don.cloneWithModal(modalFormTemplate)
                    return;
                }
                if (type === 'EDIT') {
                    this.$refs.baseForm.resetFields();
                    this.modalForm = _don.cloneWithModal(modalFormTemplate, this.modalForm, row)
                    this.modalForm.confirmPassword = this.modalForm.password
                    /*console.log(this.modalForm.positions)*/
                    if (this.modalForm.position) {
                        this.modalForm.positions = this.modalForm.position.split(',').filter(e=>e).map(e=>parseInt(e))
                        console.log(this.modalForm.positions)
                    }
                    this.modalVisible = true
                    return;
                }
                if (type === 'DELETE') {
                    this.$Modal.confirm({
                        title: '提示',
                        content: `该操作将删除检测人员“${row.userName}”，确认继续？`,
                        onOk: () => {
                            iUser.userDelete(row.id).then(() => {
                                this.$Message.success('操作成功');
                                this.getTableData();
                            }).loadingSwitch(this, 'tableLoading');
                        }
                    });
                    return;
                }
            },
            handleSubmit() {
                this.$refs.baseForm.validate(val => {
                    if (!val) return;
                    if (this.modalForm.id == null && this.modalForm.password != this.modalForm.confirmPassword) {
                        this.$Message.error('两次输入的密码不一致')
                        return
                    }
                    if (this.modalForm.positions) {
                        this.modalForm.position = ',' + this.modalForm.positions.join(',') + ','
                    }
                    if (this.modalForm.id) {
                        iUser.userUpdate(this.modalForm).then(() => {
                            this.$Message.success('操作成功');
                            this.getTableData()
                            this.modalVisible = false
                        });
                    } else {
                        iUser.userAdd(this.modalForm).then(() => {
                            this.$Message.success('操作成功');
                            this.getTableData()
                            this.modalVisible = false
                        });
                    }

                });
            },
            signDateChange(v) {
                this.modalForm.signDate = v
            },
            jobNoRangeChange(v) {
                let startTime = null
                let endtime = null
                v.length>0&&(startTime=v[0])
                v.length>1&&(endtime=v[1])
                this.modalForm.jobNoStart = startTime
                this.modalForm.jobNoEnd = endtime
            },
            handleAuthSubmit() {
                this.modalForm.places = this.$refs['placeTree'].getCheckedAndIndeterminateNodes().filter(e=>e.level==2);
                iUser.updateUserAuth(this.modalForm).then(() => {
                    this.getTableData()
                    this.drawerVisible = false;
                    this.$Message.success('操作成功');
                }).loadingSwitch(this, 'drawerLoading');
            },
            processTreeData(places) {
                return places.map(e => {
                    e.title = e.placeName
                    e.expand = true,
                        e.checked =  false,
                        e.indeterminate =  false,
                        e.children = this.processTreeData(e.children)
                    return e
                });
            },
        },
    }
</script>

<style scoped lang="less">

</style>
